import BreadCrumb from "Components/Common/BreadCrumb";
import Loader from "Components/Common/Loader";
import TableContainer from "Components/Common/TableContainer";
import { adminGetAllLogProduct } from "helpers/backend_helpers";
import { formatDate } from "helpers/globalFunction";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Input,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import DetailModalLogProduct from "./DetailModalLogProduct";
import DownloadModalLogProduct from "./Downloadmodallogproduct";

const LogProduct = () => {
  const [tableData, setTableData] = useState<any>([]);
  const [data, setData] = useState<any>({});
  const [sort, setSort] = useState("createTime");
  const [dir, setDir] = useState(-1);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [detailModal, setDetailModal] = useState<boolean>(false);
  const [downloadModal, setDownloadModal] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [filterDate, setFilterDate] = useState<any>([]);
  const [filterStatus, setFilterStatus] = useState<any>(null);
  const [filterMember, setFilterMember] = useState<any>(null);
  const [filterName, setFilterName] = useState<string>("");
  const [searchName, setSearchName] = useState<string>("");
  const [filterSender, setFilterSender] = useState<string>("");
  const [searchSender, setSearchSender] = useState<string>("");
  const [flatpickrKey, setFlatpickrKey] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchName(filterName);
      setSearchSender(filterSender);
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [filterName, filterSender]);

  const getData = () => {
    setLoading(true);
    let query: any = {
      page: pagination.pageIndex,
      size: pagination.pageSize,
      sort: sort,
      dir: dir,
    };

    if (filterDate[0] && filterDate[1]) {
      query.startDate = moment(filterDate[0]).format("YYYY-MM-DD");
      query.endDate = moment(filterDate[1]).format("YYYY-MM-DD");
    }

    if (searchName) {
      query.name = searchName;
    }

    if (searchSender) {
      query.sender = searchSender;
    }

    if (filterStatus) {
      query.type = filterStatus.value;
    }

    adminGetAllLogProduct(query)
      .then((response: any) => {
        setTableData(
          response.content.map((el: any, index: any) => {
            const { date } = el;
            return {
              ...el,
              index: index + pagination.pageIndex * pagination.pageSize + 1,
              tanggal: formatDate(date, "fullDateTime") || "-",
            };
          }),
        );
        setRowCount(response.totalElements);
        setTotalPages(response.totalPages);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const handleResetFilter = () => {
    setFilterDate([]);
    setFilterStatus(null);
    setFilterName("");
    setSearchName("");
    setFilterSender("");
    setSearchSender("");
    setFlatpickrKey((prev) => prev + 1);
  };

  const handleToggleFilter = () => {
    if (showFilter) {
      handleResetFilter();
    }
    setShowFilter(!showFilter);
  };

  const status = [
    { value: "MASUK", label: "MASUK" },
    { value: "KELUAR", label: "KELUAR" },
  ];

  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "index",
        enableColumnFilter: false,
        enableSorting: false,
        size: 50,
      },
      {
        header: "Tanggal",
        accessorKey: "tanggal",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
      },
      {
        header: "Nama Barang",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Pengirim",
        accessorKey: "sender",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Keterangan",
        accessorKey: "note",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Status",
        accessorKey: "type",
        enableColumnFilter: false,
        enableSorting: false,
        size: 150,
        cell: (cell: any) => {
          // return (
          //   <span className="badge text-uppercase bg-danger-subtle text-danger">
          //     {cell.getValue()}
          //   </span>
          // );
          switch (cell.getValue()) {
            case "MASUK":
              return (
                <span className="badge text-uppercase bg-success-subtle text-success">
                  {cell.getValue()}
                </span>
              );
            case "KELUAR":
              return (
                <span className="badge text-uppercase bg-danger-subtle text-danger">
                  {cell.getValue()}
                </span>
              );
            default:
              return (
                <span className="badge text-uppercase bg-info-subtle text-info">
                  -
                </span>
              );
          }
        },
      },

      {
        header: "Aksi",
        enableColumnFilter: false,
        enableSorting: false,
        size: 250,
        cell: (cellProps: any) => {
          return (
            <div className="hstack gap-2">
              <UncontrolledTooltip
                target={`detail-${cellProps.row.original._id}`}
              >
                Detail
              </UncontrolledTooltip>
              <button
                id={`detail-${cellProps.row.original._id}`}
                className="btn btn-sm btn-soft-info"
                onClick={() => {
                  setDetailModal(!detailModal);
                  setData(cellProps.row.original);
                }}
              >
                <i className="ri-eye-line" />
              </button>
            </div>
          );
        },
      },
    ],
    [],
  );

  useEffect(() => {
    getData();
  }, [
    pagination,
    sort,
    dir,
    searchName,
    searchSender,
    filterStatus,
    filterDate,
  ]);

  document.title = "Buku Catatan Barang";

  return (
    <React.Fragment>
      <DetailModalLogProduct
        show={detailModal}
        onCloseClick={() => setDetailModal(!detailModal)}
        data={data}
      />
      <DownloadModalLogProduct
        show={downloadModal}
        onCloseClick={() => setDownloadModal(!downloadModal)}
      />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Buku Catatan Barang" pageTitle="Buku Catatan" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="border-0">
                  <div className="d-flex align-items-center">
                    <h5 className="card-title mb-0 flex-grow-1">Data Barang</h5>
                    <div className="flex-shrink-0">
                      <div className="d-flex gap-2 flex-wrap">
                        <button
                          className="btn btn-soft-primary btn-sm"
                          onClick={handleToggleFilter}
                        >
                          <i className="ri-filter-3-line align-bottom me-1"></i>
                          Filters
                        </button>
                        <button
                          className="btn btn-soft-dark btn-sm"
                          onClick={() => setDownloadModal(!downloadModal)}
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>
                          Unduh Data
                        </button>
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardBody className="pt-0">
                  <Collapse isOpen={showFilter}>
                    <Row className="g-3 mb-4">
                      <Col lg={3}>
                        <div>
                          <Flatpickr
                            key={flatpickrKey}
                            className="form-control"
                            options={{
                              mode: "range",
                              dateFormat: "d M Y",
                            }}
                            onChange={(e) => {
                              setFilterDate(e);
                            }}
                            value={filterDate}
                            placeholder="Pilih Tanggal"
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Cari nama barang..."
                            value={filterName}
                            onChange={(e) => setFilterName(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Cari nama pengirim..."
                            value={filterSender}
                            onChange={(e) => setFilterSender(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        <Select
                          value={filterStatus}
                          onChange={(e: any) => {
                            setFilterStatus(e);
                          }}
                          options={status}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="Pilih Status"
                          isClearable
                        />
                      </Col>
                      <Col lg={12}>
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-soft-secondary btn-sm"
                            onClick={handleResetFilter}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>
                            Reset
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Collapse>
                  <div>
                    {loading ? (
                      <Loader />
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={tableData || []}
                        customPageSize={10}
                        theadClass="text-muted text-uppercase"
                        manualPagination
                        pagination={pagination}
                        pageCount={totalPages}
                        onPaginationChange={setPagination}
                        divClass="table-responsive"
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default LogProduct;
